/**
 * Deck geometry. Every printed deck is identical: the same years, the same
 * five indexes per year, so no central registry is ever needed.
 */

export const DECK_START_YEAR = 1920

/** Physical cards printed per year. Fixed — every deck is identical. */
export const CARDS_PER_YEAR = 5

/**
 * How many of a year's tracks a game actually uses, and therefore how many
 * tracks a year needs to be playable. Configurable per playlist: at 5 a year
 * needs five tracks, which few playlists manage across many years; lowering it
 * trades songs per year for more years in play.
 *
 * It can never exceed `CARDS_PER_YEAR` — there is no sixth card to scan. When
 * it is lower, the player removes any surplus cards for that year from the
 * deck; which ones they remove does not matter, because cards are matched to
 * songs as they are scanned.
 */
export const DEFAULT_TRACKS_PER_YEAR = CARDS_PER_YEAR
export const MIN_TRACKS_PER_YEAR = 1
export const MAX_TRACKS_PER_YEAR = CARDS_PER_YEAR

/** True for a whole number inside the allowed range. */
export function isValidTracksPerYear(value: unknown): value is number {
  return (
    typeof value === 'number' &&
    Number.isInteger(value) &&
    value >= MIN_TRACKS_PER_YEAR &&
    value <= MAX_TRACKS_PER_YEAR
  )
}

export const SONGSTER_URI_SCHEME = 'songster'

/** Identifies one physical card. Stringified as `<year>/<index>`. */
export interface CardId {
  year: number
  /** 1-based, 1..CARDS_PER_YEAR */
  index: number
}
